<template>
  <popup ref="popup" :show="show" :title="data.name" :footer="false" @close="close">
    <div class="desc-detail">
      {{ data.desc }}
    </div>
  </popup>
</template>

<script>
import popup from '@/components-new/popup/index.vue'

export default {
  components: {
    popup,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.desc-detail {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #595c66;
  line-height: 36px;
  font-weight: 400;
  margin-top: 16px;
  word-break: break-word;
}
</style>
